// Removes anything disallowed in name & id attributes as stated in HTML 4.
// HTML 5 allows pretty much anything but then you can run into trouble where
// can't querySelector() based on your attribute if it contains numbers, etc.
// Use this if you just wanna be safe!
function getSafeHTMLName(string) {
    return string.replace(/[^A-Za-z0-6_\-:.]/g, '');
}

export default getSafeHTMLName;
